const shippingCifFieldSelector = '.shipping-additional-fields-block input[name$="cif"]';
const shippingCifTypeFieldSelector = '.shipping-additional-fields-block select[name$="cifType"]';
const billingCifFieldSelector = 'input[name*="_billing_"][name$="cif"]:not([data-autocomplete-form=off])';
const billingCifTypeFieldSelector = 'select[name*="_billing_"][name$="cifType"]:not([data-autocomplete-form=off])';

/**
 * Show billing cif & cif type fields
 * @param {HTMLElement} billingCifField Billing element cif field
 * @param {HTMLElement} billingCifTypeField Billing element Cif type field
 */
function showBillingCifFields(billingCifField, billingCifTypeField) {
  billingCifField?.closest('.form-group').classList.remove('d-none');
  billingCifTypeField?.closest('.form-group').classList.remove('d-none');
}

/**
 * Hide billing cif & cif type fields
 * @param {HTMLElement} billingCifField Billing element cif field
 * @param {HTMLElement} billingCifTypeField Billing element Cif type field
 */
function hideBillingCifFields(billingCifField, billingCifTypeField) {
  billingCifField?.closest('.form-group').classList.add('d-none');
  billingCifTypeField?.closest('.form-group').classList.add('d-none');
}

/**
 * Checks if any shipping cif field is empty
 * @returns {boolean} True if any shipping cif field is empty, false if don't exist or are filled
 */
function isAnyShippingCifFieldEmpty() {
  const shippingCifField = document.querySelector(shippingCifFieldSelector);
  const shippingCifTypeField = document.querySelector(shippingCifTypeFieldSelector);
  return (shippingCifField && !shippingCifField.value)
    || (shippingCifTypeField && !shippingCifTypeField.value);
}

/**
 * Copies field values (if filled) from Shipping to Billing
 * if empty, shows cif fields in Billing Address to be filled.
 * @returns {void}
 */
function copyCifFieldsToBilling() {
  const billingCifField = document.querySelector(billingCifFieldSelector);
  const billingCifTypeField = document.querySelector(billingCifTypeFieldSelector);

  if (isAnyShippingCifFieldEmpty()) {
    showBillingCifFields(billingCifField, billingCifTypeField);
  } else {
    const shippingCifField = document.querySelector(shippingCifFieldSelector);
    const shippingCifTypeField = document.querySelector(shippingCifTypeFieldSelector);

    if (billingCifTypeField && shippingCifTypeField) {
      const {
        trigger,
      } = require('../common/utils/dom');

      billingCifTypeField.value = shippingCifTypeField.value;
      trigger(billingCifTypeField, 'change');
    }

    if (billingCifField && shippingCifField) {
      billingCifField.value = shippingCifField.value;
    }

    hideBillingCifFields(billingCifField, billingCifTypeField);
  }
}

module.exports = {
  methods: {
    copyCifFieldsToBilling,
  },
};
